import { http } from 'core233'
import type { AjaxResJava } from 'core233/lib/api/interface'
import type { AjaxRequestConfig } from 'core233/lib/http'

export default {
  getJ: <T>(url: string, data: any = undefined, config: AjaxRequestConfig = {}) => {
    const attache = {
      sidPre: 'ess_v3',
      ...config,
    }
    return http.getJ<AjaxResJava<T>>(url, data, attache)
  },
  postJ: <T>(url: string, data: any = undefined, config: AjaxRequestConfig = {}) => {
    const attache = {
      sidPre: 'ess_v3',
      ...config,
    }
    const newData = url.includes('?isupload=true') ? data : data ? JSON.stringify(data) : null
    return http.postJ<AjaxResJava<T>>(url, newData, attache)
  },
}
